import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { NavegacionService } from '../../core/navegacion/navegacion.service';
import { departamentoPorId, rutaBoton } from '../../core/navegacion/registro';
import { PermisosService } from '../../core/services/permisos.service';

/**
 * La puerta de las pantallas de menú (`/menu/:dep` y `/menu/:dep/:boton`), dirigida por el registro: entra quien ve al menos una tarjeta del
 * botón (o, en la pantalla de un departamento, al menos un botón). Si no, `/sin-acceso`. Un departamento de un solo botón no tiene pantalla
 * propia: `/menu/ti` lleva al botón. Lo que no existe en el registro cae en `/sin-acceso`, como cualquier dirección sin permiso.
 */
export const menuGuard: CanActivateFn = async (route) => {
  const nav = inject(NavegacionService);
  const router = inject(Router);
  const permisos = inject(PermisosService);

  await nav.cargarConcedidos();
  const depId = route.paramMap.get('dep');
  const botonId = route.paramMap.get('boton');
  const dep = departamentoPorId(depId);
  const visible = nav.departamentos().find(d => d.id === depId);

  if (!dep || !visible) {
    permisos.denegarAcceso(dep?.nombre ?? 'esta sección');
    return router.createUrlTree(['/sin-acceso']);
  }
  if (!botonId) {
    // Un solo botón visible: la pantalla del departamento es la del botón.
    if (visible.botones.length === 1) {
      const boton = dep.botones.find(b => b.id === visible.botones[0].id)!;
      return router.createUrlTree([rutaBoton(dep, boton)]);
    }
    return true;
  }
  if (!visible.botones.some(b => b.id === botonId)) {
    permisos.denegarAcceso(dep.botones.find(b => b.id === botonId)?.nombre ?? dep.nombre);
    return router.createUrlTree(['/sin-acceso']);
  }
  return true;
};
